import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import BubbleContent from '../content/bubble_content';
import ConversationItem from 'models/conversation_item';
import InlineAnnotatedContentContainer from 'components/lib/inline_annotated_content_container';

// Stub until RC-5 (sc-251411) adds the card; the message text is the selected question verbatim.
export default function ChatButtonQuestionResponseContent({ className, item, status }) {
  return (
    <BubbleContent
      className={classnames('chatItem-content button-question-response', className)}
      data-aid={`chatItem-button-question-response-${item.id}`}
      item={item}
      status={status}
    >
      <InlineAnnotatedContentContainer id={item.id} isRedacted={item.content.isRedacted} text={item.content.text} />
    </BubbleContent>
  );
}

ChatButtonQuestionResponseContent.propTypes = {
  className: PropTypes.string,
  item: PropTypes.instanceOf(ConversationItem).isRequired,
  status: PropTypes.string,
};
